module.exports = __webpack_public_path__ + "img/money-success.8d45dd4d.png";